import { useScanDeviceApiListQuery } from '@hooks/api/useScanDeviceApiListQuery';
import type { DeepScanVersion } from 'types/api';

export const useDeepScanVersions = useScanDeviceApiListQuery<DeepScanVersion>('/deepscan-versions');
